<template lang="pug">
  .btn(class="w-full h-full p-0 bg-white hover:bg-gray-light focus:bg-gray-light transition full flex items-center justify-center relative" @click.prevent="onClick")
    div(class="relative p-6")
      i.far.fa-sliders-h(class="text-secondary text-25")
      mark(class="flex items-center justify-center absolute pin-r pin-t")
        | 5
</template>
<script>
export default {
  props: {
    onClick: {
      type: Function,
      default: function () {}
    }
  }
}
</script>
